import { DecimalSeparator, DeepPartial, LocaleConfig, RoundingMethod, ThousandsSeparator } from '@empathybroker/ebx-gluon';
import * as messages from './messages';

export const MOBILE_LOCALE_CONFIG: DeepPartial<LocaleConfig> = {
  messages,
  currencies: {
    EUR: {
      decimalSeparator: DecimalSeparator.COMMA,
      thousandsSeparator: ThousandsSeparator.DOT,

    }
  }
};
